import type {Ng2StateDeclaration} from '@uirouter/angular';
import {HOLIDAY_REDUCTION} from './holiday-reduction.states';

export const HOLIDAY_REDUCTION_FEATURE = {
    name: `${HOLIDAY_REDUCTION.name}.**`,
    url: HOLIDAY_REDUCTION.url,
    loadChildren: () => import('./holiday-reduction.module').then(m => m.HolidayReductionModule),
} satisfies Ng2StateDeclaration;
